<a class="edit">
  <svg-icon class="edit__svg-icon"
    src="assets/images/icons/cart-product-edit.svg"
    [applyClass]="true"
  ></svg-icon>
  <span class="edit__text" translate>Edit book</span>
</a>
